import { Scroll } from './lib/_scroll.js';
import { kvMovie } from './components/_top_movie.js';
export var common = {
	scrl: "",
	beforeW: 0,
	init: ()=>{
		common.start();
		const hero = document.querySelector('.c-img_hero');
		if( hero ){
			let img = hero.querySelector('img');
			
			let timer = null;
			const ro = new ResizeObserver(() => {
				if (timer) clearTimeout(timer);
				timer = setTimeout(checkKv, 50);
			});
			kvMovie.resize();
			ro.observe(hero);
			img.addEventListener('load', checkKv);
		}
		
		function checkKv() {
			let img = hero.querySelector('img');
			const imgWidth = img.naturalWidth;
			const imgHeight = img.naturalHeight;
			
			if (imgWidth === 0) {
				setTimeout(checkKv, 100);
				return;
			}
			
			const heroRect = hero.getBoundingClientRect();
			const heroWidth = heroRect.width;
			const heroHeight = heroRect.height;
			
			// 画像をブロック幅に合わせたときの高さ
			const scaledHeight = heroWidth * (imgHeight / imgWidth);
			
			// ブロック自体の縦横比
			hero.classList.toggle('is-landscape', heroWidth >= heroHeight);
			hero.classList.toggle('is-portrait', heroWidth < heroHeight);
			
			// 画像との関係
			hero.classList.toggle('is-wide', heroHeight < scaledHeight);
			hero.classList.toggle('is-tall', heroHeight >= scaledHeight);
			
			if (hero.classList.contains('disable')) {
				setTimeout(() => hero.classList.remove('disable'), 200);
			}
		}
		
	},
	start: function(){
		let resizeFlag;
		let resizeTimer = null;
		let $body = document.getElementsByTagName('body')[0];
		
		common.resize();
		common.scrl = new Scroll();
		
		
		/* window resize
		----------------------------- */
		var resizeCallback = function() {
			common.resize();
			resizeTimer = null;
		};
		window.addEventListener("resize", function(){
			if( !$body.classList.contains("resize") ){
				$body.classList.add("resize");
			}
			if(resizeTimer) {
				clearTimeout(resizeTimer);
			}
			resizeTimer = setTimeout(resizeCallback, 300);
		}, false);
	},
	resize: ()=>{
		var winW 	= window.innerWidth;
		var winH 	= window.innerHeight;
		let $body 	= document.getElementsByTagName('body')[0];
		
		addressbarH();
		
		common.getScrollBar();
		
		if(common.scrl){
			common.scrl.resize();
		}
		/**/
		if( winW != common.beforeW ){
			kvMovie.resize();
		}
		setTimeout(function(){
			if( $body.classList.contains("resize") ){
				$body.classList.remove("resize");
			}
			/*
			if(common.scrl){
				common.scrl.checkBlock();
				common.scrl.checkScroll();
			}
			*/
		},300);
		function addressbarH(){
			if(common.beforeW != winW){
				// 100vh、アドレスバーが出てる時に対応
				let vh = window.innerHeight * 0.01;
				document.documentElement.style.setProperty("--vh", `${vh}px`);
			}
		}
		common.beforeW = winW;
		
	},
	getScrollBar: function(){
		const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
		document.documentElement.style.setProperty('--scrollbar', `${scrollbarWidth}px`);
	}
}
